<style></style>
<template>
    <div>

        <v-text-field
            v-if="type === 'texto'"
            v-model="value"
            :label="label"
            :rules="rules"
        >
        </v-text-field>

        <v-select
            v-else-if="type === 'seleccion_unica'"
            v-model="value"
            :label="label"
            :items="opcionesItems"
            :rules="rules"
            :menu-props="{ maxHeight: '500' }"
        >
        </v-select>

        <v-select
            v-else-if="type === 'seleccion_multiple'"
            v-model="value"
            :label="label"
            :items="opcionesItems"
            :rules="rules"
            multiple
            :menu-props="{ maxHeight: '500' }"
        >
        </v-select>

    </div>
</template>

<script>
export default {
    props: {
        config: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            value: this.config.type === 'seleccion_multiple' ? [] : null
        };
    },
    computed: {
        label() {
            return this.config.label;
        },
        type() {
            return this.config.type;
        },
        opcionesItems() {
            if (!this.config.options) return [];
            return this.config.options.map(option => ({ value: option, text: option }));
        },
        rules() {
            if (!this.config.required) return [];

            if (this.type === 'seleccion_multiple') {
                return [v => (Array.isArray(v) && v.length > 0) || 'Este campo es obligatorio'];
            }

            return [v => (v !== null && v !== '' && v !== undefined) || 'Este campo es obligatorio'];
        }
    },
    watch: {
        value: {
            deep: true,
            handler() {
                const event = {
                    index: this.index,
                    id: this.config.id,
                    value: this.value,
                    name: this.config.name,
                    type: this.config.type,
                }
                this.$emit('change', event);
            }
        }
    }
}
</script>
